export default __webpack_public_path__ + "static/media/2014-forest-hills-drive.548ffbdf.jpg";